import type { IHttpRequest } from '@hc-frontend/core-utils-net';
import {
  fetchBasedCall,
  type IHttpResponse,
} from '@hc-frontend/core-utils-net';

import type { UpdateLeadProductOptions } from './update-lead-product.types';
import { LeadProductRequestDto } from './update-lead-product.types';

export function updateLeadProduct(
  baseUrl: string,
  payload: LeadProductRequestDto,
  options?: UpdateLeadProductOptions,
): Promise<IHttpResponse<void>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<LeadProductRequestDto> = {
    url: `${baseUrl}/api/v2/journeys/lead-product`,
    method: 'PATCH',
    body: payload,
    headers,
    schemas: {
      request: LeadProductRequestDto,
    },
    ...restOptions,
  };

  return httpCall(request);
}
